import React from 'react';
import { LOGO_URL, BRAND_NAME } from '@/lib/api';

export const IndivalifeLogo = ({ size = 40, withWordmark = false, className = '' }) => {
  const px = `${size}px`;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={LOGO_URL}
        alt={BRAND_NAME}
        style={{ width: px, height: px, minWidth: px, minHeight: px }}
        className="rounded-md object-contain shrink-0 block"
        data-testid="indivalife-logo"
        onError={(e) => { e.currentTarget.style.background = '#1D4ED8'; }}
      />
      {withWordmark && (
        <span className="text-lg font-extrabold tracking-tight display whitespace-nowrap" style={{ color: '#1D4ED8' }}>{BRAND_NAME}</span>
      )}
    </div>
  );
};

export default IndivalifeLogo;
